import { ReactNode } from 'react';
import Text from '../Text';

import SubDetails from './SubDetails';
import { SubDetailsType } from './types';
import Pill from '../Pill';
import { useIsDesktop } from '../../hooks/useIsDesktop';

export interface ISideModalHeaderProps {
  text: ReactNode;
  capsules?: Array<{ key: string }>;
  subDetails?: SubDetailsType;
}

const SideModalHeader = ({ text, capsules = [], subDetails }: ISideModalHeaderProps) => {
  const isDesktop = useIsDesktop();
  
  return (
    <div className="full-flex">
      <div className="align-center">
        <Text size={isDesktop ? 'md' : 'smd'} className="bold">
        {text}
      </Text>
      {capsules.map(eachCapsule => (
        <Pill {...eachCapsule} />
      ))}
    </div>
    <SubDetails data={subDetails ?? []} />
  </div>
  );
};

export default SideModalHeader;
